import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const GetChallanDetail = (params: any) =>
  GET_ENC(API_ENDPOINTS.CHALLAN.GET_DETAIL + params, null);

export const GetChallanList = (params: any) =>
  GET_ENC(API_ENDPOINTS.CHALLAN.GET_LIST + params, null);

export const CreateChallan = (data: any) =>
  POST_ENC(API_ENDPOINTS.CHALLAN.CREATE, data, true);

export const GetChallanLastDetail = (params: any) =>
  GET_ENC(API_ENDPOINTS.CHALLAN.GET_CHALLAN_LAST_DETAIL + params, null);

export const DeleteChallan = (data: any) =>
  POST_ENC(API_ENDPOINTS.CHALLAN.DELETE, data);

export const UpdateChallan = (data: any) =>
  POST_ENC(API_ENDPOINTS.CHALLAN.UPDATE, data, true);

export const GetChallanNumber = (params: any) =>
  GET_ENC(API_ENDPOINTS.CHALLAN.GET_CHALLAN_NUMBER + params, null);

export const GetChallanDueSummaryList = (params: any) =>
  GET_ENC(API_ENDPOINTS.CHALLAN.GET_CHALLAN_DUE_SUMMARY_LIST + params, null);

export const GetChallanDueDetailList = (params: any) =>
  GET_ENC(API_ENDPOINTS.CHALLAN.GET_CHALLAN_DUE_DETAIL_LIST + params, null);
